import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { TypeEnum } from '@modules/order/models/type.enum';
import { enumEquals } from '@shared/utils/enum-utils';

export class ApplianceDetailsUtils {
	public static isApplianceDetailsEnabled(procedureId: number): boolean {
		return enumEquals(procedureId, ProcedureEnum.Appliance);
	}

	/**
	 * Returns true when the appliance type dropdown should be visible.
	 * Used in both v1 and intuitive flows — pure function, no SWO gate.
	 */
	public static isApplianceTypeVisible(procedureId: number, typeId: number): boolean {
		return (
			enumEquals(procedureId, ProcedureEnum.Appliance) &&
			(enumEquals(typeId, TypeEnum.Night_guard) || enumEquals(typeId, TypeEnum.Apnea_Sleep_Appliance))
		);
	}

	public static isApplianceDetailsEnabledForLabAndPrintRx(
		procedureId: number,
		applianceUpperValue: boolean,
		applianceLowerValue: boolean,
		applianceTypeValue: number
	): boolean {
		return (
			(procedureId as ProcedureEnum) === ProcedureEnum.Appliance &&
			(applianceUpperValue || applianceLowerValue || applianceTypeValue !== 0)
		);
	}
}
